import React from 'react';

const Phone = (fill = '#000000') => (
  <g>
    <path
      d="M7.665 3.35L5.933.436C5.493-.304 4.73.123 4.73.123L3.661.722l2.613 4.396 1.069-.6c.763-.428.322-1.168.322-1.168m4.441 12.419l-2.614-4.396c-.645.361-1.237-.306-1.781-1.023a16.378 16.378 0 0 1-1.79-3.012c-.368-.817-.645-1.662-.023-2.01L3.285.932c-.922.517-2.754 3.266.889 9.393 3.653 6.145 7.01 5.96 7.931 5.443m1.768-1.979l-1.732-2.913c-.441-.741-1.204-.313-1.204-.313l-1.069.598 2.614 4.396 1.069-.598c.763-.428.322-1.17.322-1.17"
      fill={fill}
    />
  </g>
);

export default Phone;



// WEBPACK FOOTER //
// ./src/assets/svg-icons/phone.js